module.exports = __webpack_public_path__ + "img/group17791.4d1f20e5.svg";